import React from 'react';

import { Translate } from 'react-localize-redux-dep-updated';
import { useDispatch } from 'react-redux';
import {
  Heading,
  InputText,
  SectionWrapper,
  SheetLayoutContent,
  SheetLayoutContentWrapper,
  SheetLayoutHeader,
} from '../../../../brenger-shared-ui';
import { clarity } from '../../../../configs/clarity';
import { useTypedSelector } from '../../../../hooks';
import { translate } from '../../../../utils/localization';
import FooterLayout from '../../containers/FooterLayout';
import { actions } from '../../ducks';
import { proceed } from '../../proceed';
import { numbersOnly, productPaymentSchema } from '../../schema';
import { RouteComponentProps } from 'react-router';

export const ProductPaymentAmount: React.FC<RouteComponentProps> = props => {
  const homeSituation = useTypedSelector(state => state.generalTransport.choices?.home_situation);
  const amount = useTypedSelector(state => state.generalTransport.choices?.product_payment_amount) || '';

  const [showError, setShowError] = React.useState(false);
  const dispatch = useDispatch();

  const amountError = productPaymentSchema.amount.reduce((e, validator) => {
    return e || validator(amount);
  }, undefined);

  React.useEffect(() => {
    dispatch(actions.setProgress(3));
  }, [props.location.pathname]);

  React.useEffect(() => {
    clarity.setTag('product_payment');
  }, []);

  return (
    <SheetLayoutContentWrapper>
      <SheetLayoutHeader>
        <Heading size={2} extraClasses={'no-margin pb-[0.5em]'}>
          <Translate
            id={'request_flow.headers.product_payment_amount'}
            data={{
              market_place: translate(`request_flow.home_situation.fields.type.options.${homeSituation}.name`),
            }}
          />
        </Heading>
      </SheetLayoutHeader>
      <SectionWrapper centerContent={false} sectionStyle={'primary-light'}>
        <SheetLayoutContent>
          <h6 className="mb-1">
            <Translate id={'request_flow.product_payment.fields.amount.desc'} />
          </h6>
          <div style={{ maxWidth: 290 }}>
            <InputText
              autoComplete="amount"
              name="amount"
              placeholder={translate('request_flow.product_payment.fields.amount.label')}
              value={amount}
              onChange={newAmount => dispatch(actions.setChoice({ product_payment_amount: numbersOnly(newAmount) }))}
              meta={{ error: amountError, showError }}
              append={<div style={{ padding: '.1em 3px 0 3px' }}>€</div>}
            />
          </div>
        </SheetLayoutContent>
      </SectionWrapper>
      <SectionWrapper centerContent={false} sectionStyle={'white'}>
        <SheetLayoutContent>
          <h6>
            <Translate id={'request_flow.product_payment.how_it_works_title'} />
          </h6>
          <div
            dangerouslySetInnerHTML={{
              // eslint-disable-next-line @typescript-eslint/naming-convention
              __html: String(translate('request_flow.product_payment.how_it_works_text')),
            }}
          />
        </SheetLayoutContent>
      </SectionWrapper>
      <FooterLayout customSubmitFunction={() => (!amountError ? proceed() : setShowError(true))} />
    </SheetLayoutContentWrapper>
  );
};
